export function getStoragePath(record) {
  return record?.filePath || record?.path || null;
}

export async function resolveViewUrl(record, { getSignedFileUrl } = {}) {
  if (!record) return null;
  const filePath = getStoragePath(record);
  if (filePath) {
    if (!getSignedFileUrl) return null;
    return getSignedFileUrl(filePath);
  }
  if (record.url) return record.url;
  if (record.pdfUrl) return record.pdfUrl;
  if (record.fileData) return record.fileData;
  return null;
}

